import { Route, Navigate, Outlet } from "react-router-dom";
import { createAuthRouter, ProtectedRoute, Role } from "@acto/web-common/auth";
import { TenantSettingsProvider } from "@acto/taskpane/core/contexts/TenantSettingsContext";
import { Layout } from "./Layout";
import { TeamPage } from "./pages/TeamPage";
import { CustomersPage } from "./pages/CustomersPage";
import { WorkflowPage } from "./pages/WorkflowPage";
import { ApiKeysPage } from "./pages/ApiKeysPage";

const TenantSettingsBoundary = () => (
  <TenantSettingsProvider>
    <Outlet />
  </TenantSettingsProvider>
);

// This function creates routes based on feature flags
// We can't use hooks directly in JSX passed to createAuthRouter,
// so we check the flag in the Layout component instead
const routes = (
  <Route element={<Layout />}>
    <Route path="/" element={<Navigate to="/team" replace />} />
    <Route element={<ProtectedRoute />}>
      <Route element={<TenantSettingsBoundary />}>
        <Route path="/team" element={<TeamPage />} />
        <Route path="/customers" element={<CustomersPage />} />
        <Route path="/workflows" element={<WorkflowPage />} />
      </Route>
    </Route>
    <Route element={<ProtectedRoute requiredRoles={[Role.ADMIN]} />}>
      <Route element={<TenantSettingsBoundary />}>
        <Route path="/api-keys" element={<ApiKeysPage />} />
      </Route>
    </Route>
  </Route>
);

export function createManagementRouter() {
  return createAuthRouter(routes, {
    urlStrategy: "browser",
    notFoundRedirectRoute: "/team",
    unauthorizedPageRedirectUrl: "/team",
    welcomePageRoute: "/team",
    frontegg: {
      baseUrl: import.meta.env.VITE_FRONTEGG_BASE_URL,
      clientId: import.meta.env.VITE_PUBLIC_FRONTEGG_CLIENT_ID,
    },
  });
}
